import { Box, Dialog } from "@mui/material";
import { createContext, useContext, useEffect, useState } from "react";
import { UButton } from "./ui.buttons";
import { Close } from "@mui/icons-material";

const DialogContext = createContext()
export function UDialog(props) {
    const { button, onShow, disabled, ...rest } = props;
    const [show, setShow] = useState(false)
    var ctrl = undefined;
    var ctrlDialog = undefined;

    if (button) {
        ctrl = <Box sx={{ width: '100%' }} onClick={() => { if (!disabled) { setShow(true) } }}>{button}</Box>
        ctrlDialog = {
            onClose: () => setShow(false),
            open: show,
        }
    }

    useEffect(() => {
        if (show && onShow) {
            onShow()
        }
    }, [show])

    return <DialogContext.Provider value={{ show, setShow }}>
        {ctrl}
        <Dialog {...ctrlDialog} {...rest}>
            {props.children}
        </Dialog>
    </DialogContext.Provider>
}

export function useDialog() {
    const dialog = useContext(DialogContext)

    return {
        show: dialog.show,
        setShow: dialog.setShow,
        close: () => dialog.setShow(false)

    }
}

export function UDialogCloseOnCompleteButton(props) {
    const { onComplete, ...rest } = props;
    const dialog = useDialog()
    return <UButton
        onComplete={(e) => {
            dialog.close()
            onComplete && onComplete(e)
        }}
        {...rest} />
}

export function UDialogClose(props) {
    const { onClick, ...rest } = props;
    const dialog = useDialog()
    return <UButton
        onClick={(e) => {
            onClick && onClick(e)
            dialog.close()
        }}
        {...rest} />
}

export function UDialgoCloseIcon(props) {
    const { onClick, ...rest } = props;
    const dialog = useDialog()

    return <Close
        onClick={(e) => {
            onClick && onClick(e)
            dialog.close()
        }} {...rest} />
}